// extracted by mini-css-extract-plugin
module.exports = {"displayQuestion":"answerQuestion_displayQuestion__3EsWg","answerQuestion":"answerQuestion_answerQuestion__2wrJ2"};